var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobileScreen)?_c('ylHeaderBgMobile',_vm._b({attrs:{"pageInfo":_vm.pageInfoApp}},'ylHeaderBgMobile',_vm.$attrs,false)):_c('ylHeaderBgPC',_vm._b({attrs:{"pageInfo":_vm.pageInfo}},'ylHeaderBgPC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }